import { lazy, Suspense } from 'react';
import Header from '@/components/Header';
import HeroSectionV2 from '@/components/HeroSectionV2';
import SEO from '@/components/SEO';
import { getOGImage } from '@/lib/ogImages';

// Defer everything below the fold so the LCP (hero) isn't held back by
// hydration/render of secondary sections, scroll observers, queries, etc.
const ScrollReveal = lazy(() => import('@/components/ScrollReveal'));
const ValueProposition = lazy(() => import('@/components/ValueProposition'));
const DynamicBlogGrid = lazy(() => import('@/components/DynamicBlogGrid'));
const MethodSection = lazy(() => import('@/components/MethodSection'));
const TestimonialSection = lazy(() => import('@/components/TestimonialSection'));
const CTASection = lazy(() => import('@/components/CTASection'));
const StartingPointSection = lazy(() => import('@/components/StartingPointSection'));
const CoursesSection = lazy(() => import('@/components/CoursesSection'));
const BookSection = lazy(() => import('@/components/BookSection'));
const ProgramsTeaser = lazy(() => import('@/components/ProgramsTeaser'));
const SocialSection = lazy(() => import('@/components/SocialSection'));
const Footer = lazy(() => import('@/components/Footer'));

const Index = () => {
  return <div className="min-h-screen bg-background">
      <SEO image={getOGImage('home')} />
      <Header />
      <main id="main-content" className="pt-20">
        <HeroSectionV2 />
        <Suspense fallback={<div style={{ minHeight: '50vh' }} aria-hidden="true" />}>
          <ScrollReveal variant="fade-up">
            <StartingPointSection />
          </ScrollReveal>
          <ScrollReveal variant="fade-up">
            <MethodSection />
          </ScrollReveal>
          <ScrollReveal variant="fade-up">
            <CoursesSection />
          </ScrollReveal>
          <ScrollReveal variant="fade-up">
            <BookSection />
          </ScrollReveal>
          <ScrollReveal variant="fade-up">
            <ValueProposition />
          </ScrollReveal>
          <ScrollReveal variant="fade-up">
            <ProgramsTeaser />
          </ScrollReveal>
          <ScrollReveal variant="fade-up">
            <TestimonialSection />
          </ScrollReveal>
          <ScrollReveal variant="fade-up">
            <DynamicBlogGrid limit={3} />
          </ScrollReveal>
          <ScrollReveal variant="fade-up">
            <SocialSection />
          </ScrollReveal>
          <ScrollReveal variant="scale">
            <CTASection useAdaptiveContent={true} />
          </ScrollReveal>
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>;
};
export default Index;